import React from 'react'
import { EmbeddedSlideDeck, PageIntro } from '../Templates'
import { get_slide_decks } from '../../services/presentations_service'
import './presentations.css'


const SingleSlideDeckView = ({ url, title, link_url, link_text }) => {
    return (
        <React.Fragment>
            {title && (<h3 className="presentation-details">{title}</h3>)}
            <EmbeddedSlideDeck url={url} />
            <div className="presentation-details">
                {(link_url && link_text) && <a className="presentation-hyperlink" href={link_url}>{link_text}</a>}
            </div>
        </React.Fragment>
    )
}

const Presentations = () => {

    const slide_decks = get_slide_decks().data

    return (
        <React.Fragment>
            <h1>Presentations</h1>
            <PageIntro>OTS has created presentations for events and educational purposes.  We’ve compiled them here as learning resources.</PageIntro>
            <section className="presentations-grid content-box">
                {slide_decks.map((item, i) => (<div className='presentations-grid-item' index={i} >
                    <SingleSlideDeckView 
                        url={item.link} 
                        title={item.title} 
                        link_url={item.link} 
                        link_text={item.link_text} />
                </div>))
                }
            </section>
        </React.Fragment>
    )
}


export default Presentations;